export default {
    data() {
        let ruleRequired = v => (v !== null && v !== undefined && v !== '') || this.$t('formRules.required')
        let ruleEmail = v => /.+@.+/.test(v) || this.$t('formRules.invalid', ['Email'])
        /* eslint-disable no-useless-escape */
        let ruleUrl = v => /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]*[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(v) || this.$t('formRules.invalid', ['URL'])
        return {
            valid: true,
            formRules: {
                required: [ruleRequired],
                email: [ruleEmail],
                url: [ruleUrl]
            }
        }
    }
}
